/**
 * @authors wangxu (you@example.org)
 * @date    2019-04-08 11:14:25
 * @version $Id$
 */
/* eslint-disable no-new */
import axios from 'axios'
import Vue from 'vue'
import { showMsg } from './utils'
import store from '@/store'
import router from '@/router'
import {
  Loading,
  Message
} from 'element-ui'
// axios.defaults.timeout = 6000

var loadingNum = 0
var loading = null

function handleError (error) {
  if(typeof error.message !== 'undefined') {
    showMsg(error.message)
  }else if(typeof error.data.resultMsg !== 'undefined'){
    showMsg(error.data.resultMsg)
  }else {
    showMsg()
  }
}

if (!window.URLSearchParams) {
  window.URLSearchParams = require('url-search-params')
}

function genQueryString (params) {
  var urlSearchParams = new URLSearchParams()
  for (let key in params) {
    urlSearchParams.append(key, params[key])
  }
  return urlSearchParams
}

axios.defaults.baseURL = process.env.BASE_URL
// axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  config => {
    startLoading()
    if (localStorage.getItem('token')) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}` // `Bearer ${store.state.token}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
axios.interceptors.response.use(
  response => {
    // console.log(response, 'response')
    /*switch (response.status) {
      case 401://没权限跳转登录
        // clearLoacalStorage();
        router.replace({
          path: '/login',
          query: {Rurl: router.currentRoute.fullPath}
        })
    }*/
    endLoading()
    Message.closeAll()
    let msg = response.data.resultMsg || '登录认证失效，请重新登录！'
    if(response.data.code == '401' || response.data.code == 401){
      // clearLoacalStorage();
      store.commit("CLEAR_USERINFO");
      router.replace({
        path: '/login'
      });
      localStorage.setItem('loginMsg', msg)
    }
    // console.log('response', response)
    return response
  },
  error => {
    endLoading()
    Message.closeAll()
    if (error.response) {
      let msg = error.response.data && error.response.data.resultMsg || '登录认证失效，请重新登录！'
      if(error.response.status) {
        switch (error.response.status) {
          case 401:
            // 返回 401 清除token信息并跳转到登录页面
            // store.commit('types.LOGOUT')
            store.commit("CLEAR_USERINFO")
            window.location.href = error.response.data
            // router.replace({
            //   path: '/login'
            //   //query: { redirect: router.currentRoute.fullPath }
            // })
            localStorage.setItem('loginMsg', msg)
            sessionStorage.setItem('currentProjectInfo', '')
            sessionStorage.setItem('alarmInfo', '')
            sessionStorage.setItem('fieldRules', '')
            sessionStorage.setItem('scheduleInfo', '')
            sessionStorage.setItem('tableRules', '')
            sessionStorage.setItem('taskManage', '')
          case 600:
            window.location.href = error.response.data
            store.commit('CLEAR_USERINFO')
            sessionStorage.setItem('currentProjectInfo', '')
            sessionStorage.setItem('alarmInfo', '')
            sessionStorage.setItem('fieldRules', '')
            sessionStorage.setItem('scheduleInfo', '')
            sessionStorage.setItem('tableRules', '')
            sessionStorage.setItem('taskManage', '')
        }
        if(error.response.status == 401) {
          return new Promise(() => {}); // 中断链式调用
        }
      }
    }
    
    // return Promise.reject(error.response)// 返回接口返回的错误信息
  }
)
export function _post (url, params) {
  return axios
    .post(url, params)
    .then(res => {
      if(res && res.data) {
        if (res.data.code === '0000') {
          return res.data
        }else if(res.data.code === '9999' || res.data.code === 9999){
          // return res.data
          showMsg(res.data.message)
        }else if(res.data.code === '400' || res.data.code === 400){
          return res.data
        }else if(res.data.code === '300' || res.data.code === 300){
          return res.data
        }else if (res.data.code == '500') {
          return res.data
        } else {
          showMsg(res.data.resultMsg)
        }
      }
    })
    .catch(error => {
      handleError(error)
    })
}
export function _get (url, params) {
  return axios
    .get(url, {
      params: params
    })
    .then(res => {
      // return res.data // mock数据
      if(res && res.data) {
        if (res.data.code === '0000') {
          return res.data
        } else {
          showMsg(res.data.message)
        }
      }
    })
    .catch(error => {
      handleError(error)
    })
}
export function postForm (url, params) {
  return axios
    .post(url, genQueryString(params))
    .then(res => {
      if (res.data.code === '200' || res.data.code === 200) {
        return res.data
      } else {
        showMsg(res.data.msg)
      }
    })
    .catch(error => {
      handleError(error)
    })
}

export const startLoading = () => {
  if (loadingNum === 0) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  loadingNum++
}

export const endLoading = () => {
  loadingNum--
  if (loadingNum <= 0 && loading) {
    loading.close()
  }
}


// WEBPACK FOOTER //
// ./src/api/fetch.js